<script>
  import { onMount, onDestroy } from 'svelte'
  import { writable } from "./localStorageStore.js";
  import { count } from "./stores.js";
  // import Sparkle from "./Sparkle.svelte";
  import confetti from "./confetti.min.js";
  import { quest } from "./taskTipStore.js";
  import { user } from "./userStore.js";
  import TaskCard from "./TaskCard.svelte";
  import TipCard from "./TipCard.svelte";

  import { quintOut, expoInOut, cubicOut } from "svelte/easing";
  import { quintIn, quintInOut } from "svelte/easing";
  import { crossfade } from "svelte/transition";
  import { flip } from "svelte/animate";

  import { fade, scale, blur, fly, slide, draw } from 'svelte/transition';


  // export let prod = false;

  if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k]);

  // const concat_ = (x,y) => x.concat(y);
  // const flatMap_ = (f,xs) => xs.map(f).reduce(concat_, []);
  // Array.prototype.flatMap = function(f) {
  //   return flatMap_(f,this)
  // }
// BEGIN polyfill_flatMap
if (!Array.prototype.flatMap) {
    Object.defineProperty(Array.prototype, 'flatMap', {
        value: function(callback, thisArg) {
            var self = thisArg || this;
            if (self === null) {
                throw new TypeError( 'Array.prototype.flatMap ' +
                'called on null or undefined' );
            }
            if (typeof callback !== 'function') {
                throw new TypeError( callback +
                ' is not a function');
            }

            var list = [];

            // 1. Let O be ? ToObject(this value).
            var o = Object(self);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            for (var k = 0; k < len; ++k) {
                if (k in o) {
                    var part_list = callback.call(self, o[k], k, o);
                    list = list.concat(part_list);
                }
            }

            return list;
        }
    });
}
// END polyfill_flatMap  

  onDestroy(() => {  
    console.log('destroyed');
  });

  $: testQuestJSON = JSON.stringify($quest, null, 2);
  $: testUserJSON = JSON.stringify($user, null, 2);


  // $: console.log('$quest.loading ', $quest.loading);
  // $: console.log('$user.loading ', $user.loading);
  // $: console.log('$quest.name ', $quest.name);
// $: currentTask = $user.tasks.find(
//     task => $user.currentTask && task.id == $user.currentTask.id
//   );  

  // если у юзера есть задача с этим же id и она .done, то включить ее в результат
  // $: doneTasks = $tasks.filter(task => $userTasks.reduce((a, ut) => {ut.id === task.id && ut.done && a}));
  $: doneTasks = $user.tasks
    .filter(ut => ut.done);
    // .flatMap(ut => $user.tasks.filter(t => t.id == ut.id));

  // $: checkTasks = $tasks.filter(task => task.check);
  $: checkTasks = $user.tasks
    .filter(ut => ut.check && !ut.done);
    // .flatMap(ut => $user.tasks.filter(t => t.id == ut.id));

  $: notCompletedTasks = $user.tasks.filter(ut =>
    !ut.done && !ut.check && ut.open
  );

  $: inaccessibleTasks = $user.tasks.filter(
    task =>
      !doneTasks.includes(task) &&
      !checkTasks.includes(task) &&
      !notCompletedTasks.includes(task)
  );

  $: tipsForTask =
    $user.currentTask == undefined || $user.currentTask.tips == undefined || $user.currentTask.tips.length <= 0
      ? []
      : $user.currentTask.tips.flatMap(i => $user.tips.filter(tip => tip.id == i));

    // .flatMap(t => t.tips && t.tips.filter(tip => !tip.viewed))

  // $: unreadTips = $user.tasks.filter(task => doneTasks.includes(task))
  //   .flatMap(t => t.tips && t.tips.filter(tip => !tip.viewed))
  //   .flatMap(i => $user.tips.filter(tip => tip.id == i))
  //   .filter(tip => !tip.viewed);

  $: unreadTips = $user.tips.filter(tip => !tip.viewed)
    .filter(tip => $user.tasks.find(task => task.done && task.tips && task.tips.includes(tip.id)));

  $: viewedTips = $user.tips.filter(tip => tip.viewed);

  let doneAnimation = false;

  let showEditor = false;
  function toggleEditor(e) {
    showEditor = !showEditor;
    // if (showEditor) mountEditor();
  }

  const [send, receive] = crossfade({
    duration: d => Math.sqrt(d * 3200),

    fallback(node, params) {
      const style = getComputedStyle(node);
      const transform = style.transform === "none" ? "" : style.transform;

      return {
        duration: 600,
        easing: quintInOut,
        css: t => `
					transform: ${transform} scale(${t});
					opacity: ${t}
				`
      };
    }
  });

  function setTaskPleaseHelp(task) {
    user.setTaskPleaseHelp(task);
    $user.currentTask = null;
  }

  // function selectQuest(id) {
  //   quest.setQuestId(id);
  //   console.log("$quest " + JSON.stringify($quest));
  //   console.log("$user.tasks " + JSON.stringify($user.tasks));

  //   if (!(typeof $user.tasks !== 'undefined' && $user.tasks.length > 0)) {
  //     // console.log("inside if");
  //     let task = {
  //       id: $quest ? $quest.startTask : -5555,
  //       done: false,
  //       check: false,
  //       open: true
  //     };
  //     $user.tasks = [...$user.tasks, task];
  //     console.log("selectQuest: " + id + " task id: " + task.id);
  //   }
  // }

  // function selectUser(id) {
  //   user.setUserId(id);
  // }

  let url_string = window.location.href; // "http://www.example.com/t.html?a=1&b=3&c=m2-m3-m4-m5"; //
  let url = new URL(url_string);
  let q = url.searchParams.get("q");
  // console.log(q);

    let userEmail = window.id_current_user_email
      ? window.id_current_user_email
      // : "undefined_user";
      : "hash111";
    // user = {
    //   email: userEmail,
    //   name: window.id_current_user_name
    // };

  // user.setUserId("hash111", q);
  
</script>

<style>
  .main {
    text-align: center;
    padding: 1em;
    max-width: 840px;
    margin: 0 auto;
    top: 0px;
  }

  /* @media (min-width: 800px) { */
    h1 {
      color: #ff3e00;
      text-transform: uppercase;
      font-size: 4em;
      font-weight: 100;
      margin: 0;
    }
  /* }   */

  /* если ширина viewport меньше или равна 12450px:   */
  /* @media (max-width: 1050) { */
  /* @media (min-width: 500) {
    h1 {
      color: #ff3e00;
      text-transform: uppercase;
      font-size: 2em;
      font-weight: 100;
      margin: 0;
    }      
  } */

  /* h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 3em;
    font-weight: 100;
    margin: 0;
  }   */

  h3 {
    margin: 0;
    text-transform: uppercase;
    font-weight: 100;
    color: #ccc;
  }


  .left-info {
    width: 100%;
    height: 100%;
    top: 0;
    margin-top: 0;
    position: absolute;
    left: 0;
    margin-left: 0;
    border-radius: 0;
    background: #0f0;
    display: inline-block;
    padding-top: 20px;
    max-width: 200px;
  }
 
</style>

<div class="main">
<!-- <TaskChat id={"-M7KuuORNvDzTP3TJItg"}/>  -->
            <!-- -M7KuuORNvDzTP3TJItg -->

{#if $quest.name}
  <h1>{$quest.name}</h1>
{:else}
  {#if $quest.loading || $user.loading}
    <h1>Подождите, пожалуйста, загружаем квест...</h1>
  {:else}
    <h1>Квест не найден...</h1>
  {/if}
{/if}
  <!-- {#if $user.userScore}Ваш опыт: {$user.userScore}⭐️{/if} -->
  Ваш опыт: {$user.userScore}⭐️
  <br />
  <br />
  {#if $user.loading || $quest.loading}
  Подождите, пожалуйста, загружаем квест...
  {/if}
  <!-- {#if !$user.loading && !(Array.isArray($user.tasks)&& $user.tasks.length)}
  Квест не найден<br> FIXME
  {/if} -->

  {#if !$user.loading && notCompletedTasks.length == 0 && Array.isArray($user.tasks)&& $user.tasks.length 
    && checkTasks.length == 0}
    <h3>Поздравляем! Вы решили все задачи!</h3>
  {/if}

  {#if !$user.loading && notCompletedTasks.length == 0 && checkTasks.length > 0}
    <h3>Некоторые ваши задачи находятся на проверке. Следующие задачи будут открыты после проверки вашего решения инструктором курса</h3>
  {/if}

  

  {#if $user.currentTask}
      <span 
      transition:fade="{{delay: 0, duration: 300, easing: expoInOut }}"
      >
      <!-- in:receive="{{key: $user.currentTask.id}}" 
      out:send="{{key: $user.currentTask.id}}" -->
    <TaskCard bind:task={$user.currentTask} bind:tipsForTask expanded notcompleted/>
    </span>
  {/if}

  <!-- <div style="opacity: {$user.currentTask ? '0' : ''}"> -->
  <!-- <div style="visibility: {$user.currentTask ? 'hidden' : ''}; margin-top: {$user.currentTask ? '-9999px' : ''}"> -->
  <div style="visibility: {$user.currentTask ? 'hidden' : ''}; overflow: {$user.currentTask ? 'hidden' : ''}; height: {$user.currentTask ? '0px' : ''};">
  <!-- {#if !$user.currentTask} -->
    {#if !$user.loading && notCompletedTasks.length > 0}<h3>Выбери задачу</h3>{/if}
    <!-- <div class="card task" style="display: inline-block; background-color: {task.bgcolor}; color: #fff"  -->
      <!-- in:receive|local="{{key: task.id}}" out:send|local="{{key: task.id}}"  -->
    {#each notCompletedTasks as task, i (task.id)}
    <div style="display: inline-block" 
      in:receive="{{key: task.id}}" out:send="{{key: task.id}}" 
      animate:flip="{{duration: 1400, delay: 0}}">
    <!-- on:click={() => {
        $user.currentTask = task;
        user.resetUnreadFromTeacher(task);
    }}     -->
      <!-- <TaskCard bind:task bind:tipsForTask expanded={$user.currentTask && $user.currentTask.id == task.id} notcompleted collapsed/> -->
      <TaskCard bind:task bind:tipsForTask notcompleted collapsed/>
      <!-- <h3>{task.name}</h3> -->
    </div>
    {/each}

    {#if checkTasks.length}
      <br />
      <br />
      <h3>Задачи на проверке: {checkTasks.length}</h3>
    {/if}
    {#each checkTasks as task, i (task.id)}
    <div style="display: inline-block" 
      in:receive="{{key: task.id}}" out:send="{{key: task.id}}" 
      animate:flip="{{duration: 1400, delay: 0}}">
      <TaskCard bind:task bind:tipsForTask check collapsed/>
    </div>
    {/each}


    {#if inaccessibleTasks.length}
      <br />
      <br />
      <h3>Пока недоступные задачи: {inaccessibleTasks.length}</h3>
    {/if}
    {#each inaccessibleTasks as task, i (task.id)}
      <div style="display: inline-block" 
        in:receive="{{key: task.id}}" out:send="{{key: task.id}}" 
        animate:flip="{{duration: 1400, delay: 0}}">
        <TaskCard bind:task bind:tipsForTask inaccessible collapsed/>
      </div>
    {/each}

    {#if doneTasks.length}
      <br />
      <br />
      <h3>Вы выполнили задач: {doneTasks.length}</h3>
    {/if}
    {#each doneTasks as task, i (task.id)}
    <div style="display: inline-block;" 
      in:receive="{{key: task.id}}" out:send="{{key: task.id}}" 
      animate:flip="{{duration: 1400, delay: 0}}">
      <TaskCard bind:task bind:tipsForTask notcompleted collapsed/>
    </div>
    {/each}

    {#if unreadTips.length > 0}
      <br />
      <br />
        <h3>Непросмотренные лекции</h3>
      <br />
      {#each unreadTips as tip, i (tip.id)}
          <TipCard bind:tip/>
      {/each}
    {/if}
    <!-- {@html JSON.stringify(unreadTips, null, 2)} -->

    {#if viewedTips.length > 0}
      <br />
      <br />
        <h3>Просмотренные лекции</h3>
      <br />
      {#each viewedTips as tip, i (tip.id)}
          <TipCard bind:tip/>
      {/each}        
    {/if}

  <!-- {/if} -->
  </div>

  <br />
  <br />
</div>

<!-- {#if !prod}
  User
  <div style="text-align: left"><pre>
  {@html testUserJSON}
  </pre></div>
  AllQuest
  <div style="text-align: left"><pre>
  {@html testQuestJSON}
  </pre></div>
{/if} -->
